/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import * as THREE from "three";

const SFrameJoined = ({
  handleSetActive,
}: {
  handleSetActive: (id: number) => void;
}) => {
  const { pathname } = useLocation();
  const [src, setSrc] = useState("loc");

  useEffect(() => {
    if (pathname === "/residences") {
      setSrc("res");
    } else if (pathname === "/the-location") {
      setSrc("loc");
    }
  }, [pathname]);

  const { nodes: sphere } = useGLTF(`sphere_${src}.glb`);

  const mesh = useRef<THREE.Mesh>(null);

  const raycaster = useRef(new THREE.Raycaster());

  useFrame(({ camera }) => {
    if (mesh.current) {
      const sphereCenter = new THREE.Vector3();
      mesh.current.getWorldPosition(sphereCenter);

      const direction = camera.position.clone().sub(sphereCenter).normalize();
      raycaster.current.set(sphereCenter, direction);

      const intersects = raycaster.current.intersectObject(mesh.current);

      if (intersects.length > 0) {
        const id = Math.floor(intersects[0].faceIndex / 2);
        console.log("id", id);
        handleSetActive(id);
      }
    }
  });

  return (
    <group>
      <mesh
        scale={1}
        visible={false}
        ref={mesh}
        //  @ts-ignore
        geometry={sphere["mesh_0"].geometry}
      >
        <meshBasicMaterial
          visible={true}
          toneMapped={false}
          wireframe={true}
          side={THREE.DoubleSide}
        />
      </mesh>
    </group>
  );
};

export default SFrameJoined;
